import astronLogo from '../assets/astron_logo.png';

export default {
  brand: 'ASTRON',

  logo: {
    type: 'image',
    src: astronLogo,
    alt: 'Astron Technologies',
  },

  footer: {
    leftBrand: {
      text: 'Astron Eye',
      className: 'footer__astron',
    },
    release: {
      text: 'Internal Release',
      className: 'footer__release',
      showYear: true,
    },
    poweredBy: {
      text: 'Powered by',
      className: 'footer__powered',
    },
    rightBrand: {
      text: 'Astron Group',
      className: 'footer__astron',
    },
  },

  features: {
    inquiries: true,
    jobs: true,
    workOrders: true,
    clients: true,
    vendors: true,
    inspectors: true,
    agencies: true,
    dataManagement: true,
    userManagement: true,
    standardsMaster: true,
    clientQmsCertificates: true,
    frameworkAgreements: true,
  },
};
